export default "__VITE_ASSET__og7yHIZV__"